import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetBlocksQuery } from '../impl/blfApi/endpoints/blocks';

export const useBlocksByCustomer = (
  customerId: string | undefined,
  queryOptions?: {
    skip?: boolean;
  }
) => {
  const queryParams = useMemo(() => {
    if (!customerId || queryOptions?.skip) {
      return skipToken;
    }

    return { customer__id__in: [customerId ?? ''] };
  }, [customerId, queryOptions?.skip]);

  const {
    currentData: blocks,
    isLoading,
    isFetching,
  } = useGetBlocksQuery(queryParams, queryOptions);

  return {
    blocks,
    isBlocksLoading: isLoading || isFetching,
  };
};
